import EmptyIllustration from '../../../assets/EmptyIllustration';
import VideoTaxes from '../../../assets/Video-Taxes.png';
import {
  AnimatedFabDivider,
  ClientTaxRateScoreHealthRange,
  Divider,
  ElementDetailViewHeader,
  ElementDetailViewIndexPageContainer,
  ElementEducationVideoTile,
  ScorecardElementCalculationGroup,
} from '../../components';
import { AddIcon } from '../../icons/add';
import { TaxReturnSummaryCard } from './components';
import { useTaxRateElementDetailViewIndexPage } from './hooks';
import { TaxRateElementDetailViewIndexPageProps } from './types';

export function TaxRateElementDetailViewIndexPage({
  clickHandlers,
  downloadReportButton,
  showScoreHealthRange,
}: TaxRateElementDetailViewIndexPageProps) {
  const {
    tPages,
    tScorecard,
    householdID,
    sortedTaxes,
    isLoading,
    trDenominatorData,
    trNumeratorData,
    trScore,
    firmID,
    clientID,
    allowDocuments,
  } = useTaxRateElementDetailViewIndexPage();

  if (isLoading) return null;

  return (
    <ElementDetailViewIndexPageContainer downloadReportButton={downloadReportButton}>
      <ElementDetailViewHeader
        title={tScorecard('tax-rate')}
        tooltipContainerClassName="md:!w-[312px]"
        tooltipDescription={tPages('tax-rate-element-detail-view-header-tooltip-description')}
      />

      <ScorecardElementCalculationGroup.DefaultComponent
        element="Tr"
        score={trScore}
        className="mb-12"
        numeratorData={trNumeratorData}
        denominatorData={trDenominatorData}
      />
      {showScoreHealthRange && <ClientTaxRateScoreHealthRange firmClientID={clientID} firmID={firmID} />}
      <ElementEducationVideoTile
        thumbNail={<img src={VideoTaxes} alt="Video Taxes" />}
        body={tPages('tax-rate-element-detail-view-learn-more-body')}
        label={tPages('tax-rate-element-detail-view-learn-more-label')}
        videoId={'1018763959'}
      />
      {clickHandlers?.addTaxReturn ? (
        <AnimatedFabDivider
          hoverWidth={166}
          className="mt-12"
          onClick={clickHandlers.addTaxReturn}
          label={tPages('tax-rate-element-detail-view-fab-label')}
          icon={<AddIcon className="text-darkMode-gray-medium mix-blend-difference" />}
        />
      ) : (
        <Divider className="-ml-12 w-[calc(100%_+_96px)]" />
      )}
      {sortedTaxes.length ? (
        <div className="grid grid-flow-row gap-6 mt-12 grid-cols-1 sm:grid-cols-2">
          {sortedTaxes.map((t) => (
            <TaxReturnSummaryCard
              key={t.id}
              taxReturnSummary={t}
              householdID={householdID}
              allowDocuments={!!allowDocuments}
              clickHandlers={clickHandlers?.taxReturnSummaryCard}
            />
          ))}
        </div>
      ) : (
        <EmptyIllustration className="w-full md:w-[480px] mx-auto mt-8 sm:mt-14 text-elements-Tr" />
      )}
    </ElementDetailViewIndexPageContainer>
  );
}
